import { ValidatorFn, Validators } from '@angular/forms';
import { patternValidator } from './validators';

export const passwordValidators = (...extraValidators: ValidatorFn[]) =>
  Validators.compose([
    Validators.required,
    patternValidator(/\d/, {
      hasNumber: true
    }),
    // check whether the entered password has upper case letter
    patternValidator(/[A-Z]/, {
      hasCapitalCase: true
    }),
    // check whether the entered password has a lower case letter
    patternValidator(/[a-z]/, {
      hasSmallCase: true
    }),
    Validators.minLength(8),
    ...extraValidators
  ]);
